<div class="localization-selector">
  <div class="language-tab" [class.selected]="selected === Language.English">
    <button mat-button mgdButton type="button" (click)="onLanguageClick(Language.English)">
      {{ Language.English | mgdLanguage }}
      <span class="default-badge">DEFAULT</span>
      @if (isBaseChanged) {
        <span class="localization-indicator has-changes">
          <mat-icon aria-hidden="true" matTooltip="Has changes">edit</mat-icon>
          <span class="cdk-visually-hidden">Has changes</span>
        </span>
      }
    </button>
  </div>
  @for (language of languages; track language) {
    <div class="language-tab" [class.selected]="selected === language" [class.invalid]="isInvalid(language)">
      <button mat-button mgdButton type="button" (click)="onLanguageClick(language)">
        {{ language | mgdLanguage }}
        @if (isRequired(language)) {
          <span class="required-indicator" aria-hidden="true">*</span>
          <span class="cdk-visually-hidden">Required</span>
        }
        <!--
          Precedence, most to least severe - only one indicator ever renders per tab. Invalid
          (the host's rule fails) is checked first, then Pending Removal, which must precede
          Has Changes: clearing a localization makes its group dirty by
          definition, so if Has Changes were checked first, Pending Removal could never render.
        -->
        @if (isInvalid(language)) {
          <span class="localization-indicator invalid">
            <mat-icon aria-hidden="true" matTooltip="Required field is empty">error_outline</mat-icon>
            <span class="cdk-visually-hidden">Required field is empty</span>
          </span>
        }
        @else if (isPendingRemoval(language)) {
          <span class="localization-indicator pending-removal">
            <mat-icon aria-hidden="true" matTooltip="Pending removal">delete_outline</mat-icon>
            <span class="cdk-visually-hidden">Pending removal</span>
          </span>
        }
        @else if (isChanged(language)) {
          <span class="localization-indicator has-changes">
            <mat-icon aria-hidden="true" matTooltip="Has changes">edit</mat-icon>
            <span class="cdk-visually-hidden">Has changes</span>
          </span>
        }
        @else if (hasLocalization(language)) {
          <span class="localization-indicator has-localization">
            <mat-icon aria-hidden="true" matTooltip="Translated">translate</mat-icon>
            <span class="cdk-visually-hidden">Translated</span>
          </span>
        }
      </button>
    </div>
  }
</div>

@if (selected !== Language.English) {
  <div class="localization-banner">
    <mat-icon>translate</mat-icon>
    <span>
      Editing {{ selected | mgdLanguage }} localization. Only
      {{ textFieldNames.concat(imageFieldNames).join(" and ") }} are localized.
      Other fields are set on the English tab. Empty fields fall back to English.
    </span>
  </div>
}
